import Checkbox from "@mui/material/Checkbox";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import { useSelector } from "react-redux";

import MuiSelect from "components/molecules/MuiSelect";

import TiktokLeadLogin from "../../../TiktokLeadLogin";

/**
 * TikTok lead-source connect flow for LeadsStep1: pick an existing TikTok
 * lead source (with its pages) or log in through TiktokLeadLogin. All state
 * shared with toNext()/postStep1Datas() stays lifted in LeadsStep1.
 */
const TiktokLeadSourceSection = ({
    sourceConnectedList,
    fbReadySourceSelectStatus,
    tiktokAppStatus,
    sourceSettingsPermission,
    selectedConnectedSource,
    connectedSourceChange,
    resetConnectedSourceSelection,
    setNextButtonDisabled,
    connectionSourceName,
    handleConnectionSourceName,
    selectedPages,
    connectFaceLeadsListChanged,
    handleSelectedPages,
    receiveNewForms,
    onToggleReceiveNewForms,
    setTiktokAppStatus,
    setTiktokStoreData,
    tiktokReceiveNewForms,
    setTiktokReceiveNewForms,
    setConnectionSourceName,
    setTiktokSelectedForms,
}) => {
    const language = useSelector((state) => state.languagesState.languages);

    return (
        <>
            {sourceConnectedList && sourceConnectedList.length > 0 && (
                <div className="mb-2">
                    <div>
                        {!fbReadySourceSelectStatus &&
                            tiktokAppStatus !== "success" &&
                            sourceSettingsPermission !== "success" && (
                                <MuiSelect
                                    value={selectedConnectedSource}
                                    options={sourceConnectedList?.map(
                                        (item) => ({
                                            value: item?.id,
                                            label: item?.name,
                                        }),
                                    )}
                                    setValue={(value) => {
                                        connectedSourceChange(
                                            value,
                                            sourceConnectedList.find(
                                                (x) => x?.id === value,
                                            ),
                                        );
                                        setNextButtonDisabled(false);
                                    }}
                                    label={
                                        language?.lead_wizard?.select_pages ??
                                        "Select Tiktok Lead"
                                    }
                                    labelId="tiktok-page-lead-select"
                                />
                            )}
                        {sourceSettingsPermission === "success" && (
                            <>
                                <div className="my-3">
                                    <FormControl
                                        className="mb-3 fb-source"
                                        style={{
                                            width: "100%",
                                            position: "relative",
                                        }}
                                    >
                                        {fbReadySourceSelectStatus && (
                                            <div className="tiktok-established-area">
                                                <span className="source-established-label">
                                                    <img
                                                        src="assets/images/typeImages/tiktok-icon.png"
                                                        alt=""
                                                    />
                                                    {language?.lead_wizard
                                                        ?.facebook_connection_established ??
                                                        "Tiktok connection established"}
                                                </span>
                                                <button
                                                    type="button"
                                                    className="source-established-reset"
                                                    onClick={
                                                        resetConnectedSourceSelection
                                                    }
                                                >
                                                    {language?.lead_wizard
                                                        ?.reselect_source ??
                                                        "Reselect source"}
                                                </button>
                                            </div>
                                        )}
                                        <TextField
                                            name="source-name"
                                            label={"Source Name"}
                                            variant="outlined"
                                            onChange={
                                                handleConnectionSourceName
                                            }
                                            placeholder={"Source Name"}
                                            value={connectionSourceName}
                                            error={connectionSourceName === ""}
                                            className="text-field-ui-workaround"
                                        />
                                    </FormControl>
                                    <MuiSelect
                                        value={selectedPages}
                                        options={connectFaceLeadsListChanged}
                                        setValue={handleSelectedPages}
                                        label={
                                            language?.lead_wizard
                                                ?.select_pages ??
                                            "Select page(s)"
                                        }
                                        labelId="tiktok-page-select-label"
                                        className="tour-tiktok-pages-select"
                                        multiple
                                        withChip
                                        disableCloseOnSelect
                                        renderSelectAll
                                    />
                                </div>
                                {selectedPages.length > 0 && (
                                    <div className="my-3">
                                        <FormControlLabel
                                            className="newForm m-0"
                                            control={
                                                <Checkbox
                                                    checked={receiveNewForms}
                                                    onChange={
                                                        onToggleReceiveNewForms
                                                    }
                                                />
                                            }
                                            label={
                                                language?.lead
                                                    ?.forms_automatically ??
                                                "Add new forms automatically"
                                            }
                                        />
                                        <Typography
                                            variant="body2"
                                            color="text.secondary"
                                            sx={{
                                                pl: 5.5,
                                            }}
                                        >
                                            {language?.lead
                                                ?.new_created_forms ??
                                                "New created forms will be included in your integration automatically"}
                                        </Typography>
                                    </div>
                                )}
                            </>
                        )}
                        {tiktokAppStatus !== "success" &&
                            sourceSettingsPermission !== "success" && (
                                <div className="wizard-or-area mt-2 mb-2">
                                    Or Create New Tiktok Lead Source
                                </div>
                            )}
                    </div>
                </div>
            )}
            {sourceSettingsPermission !== "success" &&
                !fbReadySourceSelectStatus && (
                    <TiktokLeadLogin
                        setTiktokAppStatus={setTiktokAppStatus}
                        setStoreData={setTiktokStoreData}
                        receiveNewForms={tiktokReceiveNewForms}
                        setRecieveNewForms={setTiktokReceiveNewForms}
                        setSourceName={setConnectionSourceName}
                        setTiktokForms={setTiktokSelectedForms}
                    ></TiktokLeadLogin>
                )}
        </>
    );
};

export default TiktokLeadSourceSection;
